import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
const config = process.env

const HealthStatsSuccessMsg = () => {
  return (
    <div className="submit-stats-success">
      <div>
        <img
          src={`${config.REACT_APP_CDN_URL}trophy.svg`}
          alt=""
          className="submit-stats-success-img"
        />
      </div>
      <Paragraph className="submit-stats-success-text">
        High five! You submitted your daily stats. Work hard, stay consistent
        and keep recording your stats!
      </Paragraph>
    </div>
  )
}

export default HealthStatsSuccessMsg
